import React, { Component } from "react";
import Table from '../../../components/UI/Table/Table'
import { Link } from "react-router-dom";

let that;
const columns = [
  {
    Header: "Case Name",
    id: "counterpartyName",
    accessor: p => (
      <Link
        id={p.caseId}
        to={`/case/view/${p.caseId}`}
        title={p.caseId}
        className={p.status === "FAILURE" ? "text-danger" : ""}
      >
        {p.counterpartyName}
      </Link>
    ),
    width: 150
  },
  {
    Header: "Corporate Name",
    accessor: "companyName",
    width: 150
  },
  {
    Header: "Partner Name",
    accessor: 'partnerName'
  },
  {
    Header: "Order Number",
    accessor: "orderNumber"
  },
  {
    Header: "Country",
    accessor: "country"
  },
  {
    Header: "Request Date",
    accessor: "requestDate"
  },
  {
    Header: "Response Date",
    accessor: "responseDate"
  },
  {
    Header: "Status",
    id: "status",
    accessor: p =>
      <i className={p.status === 'PENDING' ? 'fa fa-spinner crawler-status-icon text-warning'
        : (p.status === 'COMPLETED' ? 'fa fa-check-circle crawler-status-icon text-success'
          : (p.status === 'FAILURE' ? 'fa fa-times-circle crawler-status-icon text-danger'
            : (p.status === 'UNALLOCATED' ? 'fa fa-play-circle crawler-status-icon text-primary' 
            : 'fa fa-exclamation-triangle crawler-status-icon text-warning')))}
        data-toggle="tooltip" data-placement="top" title={p.status}
      >
      </i>,
    width: 75
  }
]

class IntlDashboardTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.tasks,
      noOfPages: this.props.noOfPages,
      sorted: {
        id: "requestDate",
        desc: true,
      },
      skip: 0,
      limit: 10,
      currentPage: 0
    };
    that = this;
  }

  resetPagination(){
    this.setState({
      currentPage: 0
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.tasks !== prevProps.tasks) {
      this.setState({
        data: this.props.tasks,
      });
    }
  }

  render() {
    return (
      <div>
        <Table
          data={this.state.data ? this.state.data : []}
          columns={columns}
          defaultSorted={[
            {
              id: "requestDate",
              desc: true,
            },
          ]}
          className=""
          noDataText="No Partner Orders Available"
          multiSort={false}
          pages={this.props.noOfPages}
          page={this.state.currentPage}
          defaultPageSize={10}
          showPagination={true}
          showPaginationTop={false}
          showPaginationBottom={true}
          manual // this would indicate that server side pagination has been enabled
          loading={this.props.loading}
          onPageChange={pageIndex => {
            // Called when the page index is changed by the user
            this.setState({
              skip: pageIndex * this.state.limit,
              currentPage: pageIndex
            });
            this.props.onFetchPage(
              pageIndex * this.state.limit,
              this.state.limit,
              this.state.sorted,
            );
          }}
          onSortedChange={(newSorted, column, shiftKey) => {
            // Called when a sortable column header is clicked with the column itself and if the shiftkey was held. If the column is a pivoted column, 'column' will be an array of columns
            this.setState({
              sorted: newSorted[0],
            });
            this.props.onFetchPage(
              this.state.skip,
              this.state.limit,
              newSorted[0],
            );
          }}
          onPageSizeChange={(pageSize, pageIndex) => {
            this.setState({
              limit: pageSize
            });
            this.props.onFetchPage(
              this.state.skip,
              pageSize,
              this.state.sorted,
            );
          }}
        />
      </div>
    );
  }
}

export default IntlDashboardTable;